










import { ENotificationStatus, INotification } from '@/models/notification';
import DateUtils from '@/utils/DateUtils';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class NotificationMenuItem extends Vue {
  @Prop() notification!: INotification;

  get isNew() {
    return this.notification.status === ENotificationStatus.NEW;
  }

  get date() {
    return DateUtils.formattedDate({
      date: this.notification.createdAt,
      applyTimezone: true,
      format: 'MMM D, YYYY [at] H:MM A'
    });
  }
}
